import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import { Box, Button } from '@mui/material'
import StateComponents from '../../../../components/state-component/StateComponents'
import { debouncedApiCall } from '../../../../utils/app.utils'
import { icons } from '../../../../assets/icons/icons'
import TableCustom from '../../../../components/table/tableCustom'
import { useTranslation } from 'react-i18next'
// import { dateTimeToView } from '../../../../utils/date.utils'
// import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom'
import TableRowCommon from '../../../../components/table/TableRowCommon'
import { IconComponent } from '../../../../assets/icons/iconComponent'
import { ELibraryManagementApi, report_data_e_library, report_period_data_e_library } from '../../../../api/e-library/e_library_management'
import { useDispatch } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { libraryDetailHistoryOptions, media_type_data_category, periodOptions, PERSON_TYPE_OPTIONS } from '../../enum/elibrary_enum'
import moment from 'moment'
import { ReportApi } from '../../../../api/report/Report.api'
import { saveAs } from 'file-saver'

type Props = {}

const ManageReport: React.FC<Props> = ({ }: Props) => {

    const dispatch = useDispatch();

    const { t } = useTranslation();
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);
    const [library_category_name, set_library_category_name] = useState<{ name: string, value: string } | null>(null);
    const [actions, set_actions] = useState<{ label: string, value: string } | null>(null);
    const [type_user, set_type_user] = useState<{ label: string, value: number } | null>(null);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);

    const [period, set_period] = useState<any>(null);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_library_banner", width: 80, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "date", disablePadding: false, width: 80, align: "center", label: t("วันที่")
        },
        {
            id: "time", disablePadding: false, width: 80, align: "center", label: t("เวลา")
        },
        {
            id: "1", disablePadding: false, width: 140, align: "center", label: t("ประเภทสื่อ")
        },
        {
            id: "2", disablePadding: false, width: 200, align: "center", label: t("ชื่อสื่อ")
        },
        {
            id: "3", disablePadding: false, width: 140, align: "center", label: t("ชื่อผู้ใช้")
        },
        {
            id: "4", disablePadding: false, width: 140, align: "center", label: t("ประเภทผู้ใช้")
        },
        {
            id: "45", disablePadding: false, width: 140, align: "center", label: t("รายละเอียดของการกระทำ")
        },
        {
            id: "5", disablePadding: false, width: 140, align: "center", label: t("IP Address")
        },
    ];
    const headCellPeriod = [
        {
            id: "id_library_banner", width: 50, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "date", disablePadding: false, width: 100, align: "center", label: t("ช่วงเวลา")
        },
        {
            id: "time", disablePadding: false, width: 100, align: "center", label: t("ยืม")
        },
        {
            id: "1", disablePadding: false, width: 100, align: "center", label: t("ดาวน์โหลด")
        },
        {
            id: "2", disablePadding: false, width: 100, align: "center", label: t("จอง")
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            // modified_date,
            full_name,
            library_head_name,
            library_category_name,
            created_date,
            user_type,
            library_detail_type,
            ip_address,
            period_label,
            count_borrow,
            count_download,
            count_booked
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: period ? [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "center",
                    label: period_label || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: count_borrow || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: count_download || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: count_booked || "-"
                },

            ] : [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: created_date ? moment(created_date).format("DD/MM/YYYY") : "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: created_date ? moment(created_date).format("HH:mm:ss") : "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: t(media_type_data_category?.find((x) => x.value === library_category_name)?.name || "-")
                },

                {
                    option: "TEXT",
                    align: "left",
                    label: library_head_name || "-"
                },

                {
                    option: "TEXT",
                    align: "left",
                    label: full_name || "-"
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: user_type || "-"
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: t(libraryDetailHistoryOptions?.find((x) => x.value === library_detail_type)?.label || "-")
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: ip_address || "-"
                },
                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     class: matches && data.length > 0,
                //     component: <div className='flex justify-center items-center'>
                //         <OptionsButtonCustom
                //             enableView

                //         />
                //     </div>
                // },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };



    const handleGetData = useCallback(async () => {
        let query: report_data_e_library = {
            page: page,
            limit: pageLimit
        }
        if (search) query.search = search;
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");
        if (library_category_name) query.library_category_name = library_category_name?.value;
        if (actions) query.action = actions.value;
        if (type_user) query.type_user = +type_user.value ? +type_user.value : undefined;
        dispatch(setLoading());
        await ELibraryManagementApi.listReport(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_data(response?.items || []);
                setTotalItems(response?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            set_data([]);
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, search, period, start_date, end_date, library_category_name, actions, type_user])

    const handleGetDataPeriod = useCallback(async (type: string) => {
        let query: report_period_data_e_library = {
            page: page,
            limit: pageLimit,
            type
        }
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.end_date = moment(end_date).format("YYYY-MM-DD");

        dispatch(setLoading());
        await ELibraryManagementApi.listPeriod(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_data(response?.items || []);
                setTotalItems(response?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            set_data([]);
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, search, period, start_date, end_date])


    const handleDownloadFile = async (type: "DATA" | "PERIOD", type_file: "xlsx" | "pdf", params: {
        library_category_name?: string;
        action?: string;
        search?: string;
        start_date?: string | null;
        end_date?: string | null;
        type_user?: number;
        period?: string;
    }) => {
        if (type === 'DATA') {
            dispatch(setLoading());
            await ReportApi.logELibraryData({
                library_category_name: params.library_category_name || undefined,
                action: params?.action || undefined,
                search: params?.search || undefined,
                start_date: params.start_date ? moment(params.start_date).format("YYYY-MM-DD") : undefined,
                end_date: params.end_date ? moment(params.end_date).format("YYYY-MM-DD") : undefined,
                type_user: params.type_user ? +params.type_user : undefined,
                type_file
            }).then((res) => {
                if (res.status < 300) {
                    const response = res.data;
                    const blob_file = new Blob([response], {
                        type: type_file === 'xlsx' ?
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "application/pdf"
                    })
                    saveAs(blob_file, 'report_logs_e_library')
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
        else if (type === 'PERIOD' && params.period) {
            dispatch(setLoading());
            await ReportApi.logELibraryPeriod({
                type: params.period,
                start_date: params.start_date ? moment(params.start_date).format("YYYY-MM-DD") : undefined,
                end_date: params.end_date ? moment(params.end_date).format("YYYY-MM-DD") : undefined,
                type_file
            }).then((res) => {
                if (res.status < 300) {
                    const response = res.data;
                    const blob_file = new Blob([response], {
                        type: type_file === 'xlsx' ?
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "application/pdf"
                    })
                    saveAs(blob_file, 'report_logs_e_library_period_time')
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
        return
    }


    useEffect(() => {
        if (!period) {
            handleGetData();
        }
    }, [handleGetData])

    useEffect(() => {
        if (period) {
            handleGetDataPeriod(period?.value)
        }
    }, [handleGetDataPeriod])
    return (
        <ContainerLayout
            title={t("รายงานการใช้ E-Library")}
            navigateContent={
                <></>
            }
            buttonContent={
                <Box className="flex justify-end items-center gap-4">
                    {period ? (
                        <>
                            <Button
                                onClick={() => handleDownloadFile('PERIOD', 'xlsx', {
                                    action: actions?.value,
                                    end_date: end_date,
                                    library_category_name: library_category_name?.value,
                                    period: period?.value,
                                    search: search,
                                    start_date: start_date,
                                    type_user: type_user?.value
                                })}
                                color='success'
                                variant='contained' startIcon={<IconComponent.CSVIcon />}>{t("ดาวน์โหลด Excel")}</Button>
                            <Button
                                onClick={() => handleDownloadFile('PERIOD', 'pdf', {
                                    action: actions?.value,
                                    end_date: end_date,
                                    library_category_name: library_category_name?.value,
                                    period: period?.value,
                                    search: search,
                                    start_date: start_date,
                                    type_user: type_user?.value
                                })}
                                color='error'
                                variant='contained' startIcon={<IconComponent.PDFIcon />}>{t("ดาวน์โหลด PDF")}</Button>
                        </>
                    ) : <>
                        <Button
                            onClick={() => handleDownloadFile('DATA', 'xlsx', {
                                action: actions?.value,
                                end_date: end_date,
                                library_category_name: library_category_name?.value,
                                period: period?.value,
                                search: search,
                                start_date: start_date,
                                type_user: type_user?.value
                            })}
                            color='success'
                            variant='contained' startIcon={<IconComponent.CSVIcon />}>{t("ดาวน์โหลด Excel")}</Button>
                        <Button
                            onClick={() => handleDownloadFile('DATA', 'pdf', {
                                action: actions?.value,
                                end_date: end_date,
                                library_category_name: library_category_name?.value,
                                period: period?.value,
                                search: search,
                                start_date: start_date,
                                type_user: type_user?.value
                            })}
                            color='error'
                            variant='contained' startIcon={<IconComponent.PDFIcon />}>{t("ดาวน์โหลด PDF")}</Button>
                    </>
                    }
                </Box>
            }
            content={
                <Box>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label ? t(op.label) : "",
                                    labelId: "11E",
                                    onChange: (_, val) => set_period(val ?? null),
                                    options: periodOptions || [],
                                    value: period || null,
                                    placeholder: t("รายละเอียด"),
                                }
                            },
                            {
                                seq: 1.1,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                hidden: !!period,
                                type: "TEXT_FIELD",
                                fieldProps: {
                                    startAdornment: <Box mr={1}><icons.SearchNormal /></Box>,
                                    placeholder: t("ค้นหาชื่อ"),
                                    onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                }
                            },
                            {
                                seq: 2,
                                hidden: !!period,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label ? t(op.label) : "",
                                    labelId: "11",
                                    onChange: (_, val) => set_type_user(val),
                                    options: PERSON_TYPE_OPTIONS,
                                    value: type_user || null,
                                    placeholder: t("ทุกประเภทผู้ใช้"),
                                }
                            },
                            {
                                seq: 3,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                hidden: !!period,
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.name ? t(op.name) : "",
                                    labelId: "22",
                                    onChange: (_, val) => set_library_category_name(val ?? null),
                                    options: media_type_data_category || [],
                                    value: library_category_name || null,
                                    placeholder: t("ทุกประเภทสื่อ"),
                                }
                            },
                            {
                                seq: 4,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                hidden: !!period,
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label ? t(op.label) : "",
                                    labelId: "33",
                                    onChange: (_, val) => set_actions(val ?? null),
                                    options: libraryDetailHistoryOptions,
                                    value: actions || null,
                                    placeholder: t("ทุกการกระทำ"),
                                }
                            },
                            // {
                            //     seq: 5,
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 6,
                            //         xl: 3
                            //     },
                            //     type: "AUTO-COMPLETE",
                            //     fieldProps: {
                            //         getOptionLabel: () => "",
                            //         labelId: "44",
                            //         onChange: () => { },
                            //         options: [],
                            //         value: null,
                            //         placeholder: "ทุกปี",
                            //     }
                            // },
                            // {
                            //     seq: 6,
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 6,
                            //         xl: 3
                            //     },
                            //     type: "AUTO-COMPLETE",
                            //     fieldProps: {
                            //         getOptionLabel: () => "",
                            //         labelId: "55",
                            //         onChange: () => { },
                            //         options: [],
                            //         value: null,
                            //         placeholder: "ทุกเดือน",
                            //     }
                            // },
                            // {
                            //     seq: 7,
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 6,
                            //         xl: 3
                            //     },
                            //     type: "AUTO-COMPLETE",
                            //     fieldProps: {
                            //         getOptionLabel: () => "",
                            //         labelId: "66",
                            //         onChange: () => { },
                            //         options: [],
                            //         value: null,
                            //         placeholder: "ทุกสัปดาห์",
                            //     }
                            // },
                            {
                                seq: 8,
                                gridProps: {
                                    xs: 12,
                                    md: 6,
                                    xl: 3
                                },
                                type: "DATE_RANGE2",
                                fieldProps: {
                                    handleChange: (st, end) => {
                                        set_start_date(st);
                                        set_end_date(end)
                                    },
                                    value: {
                                        end_date,
                                        start_date
                                    },
                                    placeholder: t("ช่วงวันที่"),
                                }
                            },
                        ]}
                    />


                    <section className='w-full mt-4'>
                        <TableCustom
                            tableMinWidth={period ? 1440 : 1920}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={period ? headCellPeriod : headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                </Box>
            }
        />
    )
}

export default ManageReport